import styled from 'styled-components';
var ListHeading = styled.h4.withConfig({
  displayName: "ModalSuccessStatestyles__ListHeading",
  componentId: "jdezwj-0"
})(["display:flex;align-items:center;svg{margin-right:10px;}"]);
var Description = styled.div.withConfig({
  displayName: "ModalSuccessStatestyles__Description",
  componentId: "jdezwj-1"
})(["margin-bottom:0.625rem;li{display:flex;margin-bottom:8px;}"]);
var Circle = styled.div.withConfig({
  displayName: "ModalSuccessStatestyles__Circle",
  componentId: "jdezwj-2"
})(["background-color:", ";border-radius:50%;position:relative;min-width:24px;width:24px;height:24px;margin-right:8px;svg{position:absolute;top:5px;left:5px;fill:", ";}"], function (props) {
  return props.theme.color.monochrome.lighter;
}, function (props) {
  return props.theme.color.palette['brand-3'];
});
var ContentListText = styled.span.withConfig({
  displayName: "ModalSuccessStatestyles__ContentListText",
  componentId: "jdezwj-3"
})(["margin-left:10px;line-height:normal;"]);
export { ListHeading, Description, Circle, ContentListText };